export default __webpack_public_path__ + "static/media/translator.3d94a384.svg";